import { extendTheme } from "@mui/joy/styles";

const theme = extendTheme({
  // "colorSchemes": {
  //   "light": {
  //     "palette": {
  //       "background": {
  //         "surface": "#f5f8fb",
  //       },
  //       "primary": {
  //         "50": "#eef2ff",
  //         "100": "#e0e7ff",
  //         "200": "#c7d2fe",
  //         "300": "#a5b4fc",
  //         "400": "#818cf8",
  //         "500": "#6366f1",
  //         "600": "#4f46e5",
  //         "700": "#4338ca",
  //         "800": "#3730a3",
  //         "900": "#312e81"
  //       },
  //       "neutral": {
  //         "50": "#f8fafc",
  //         "100": "#f1f5f9",
  //         "200": "#e2e8f0",
  //         "300": "#cbd5e1",
  //         "400": "#94a3b8",
  //         "500": "#64748b",
  //         "600": "#475569",
  //         "700": "#334155",
  //         "800": "#1e293b",
  //         "900": "#0f172a",
  //         "softBg": "#dfe3e8",
  //       },
  //       "danger": {
  //         "50": "#fbe9e7",
  //         "100": "#ffccbc",
  //         "200": "#ffab91",
  //         "300": "#ff8a65",
  //         "400": "#ff7043",
  //         "500": "#ff5722",
  //         "600": "#f4511e",
  //         "700": "#e64a19",
  //         "800": "#d84315",
  //         "900": "#bf360c"
  //       }
  //     }
  //   },
  // },
  components: {
    JoyButton: {
      defaultProps: {
        variant: "plain",
        color: "neutral",
        // size: "lg",
      },
      styleOverrides: {
        root: {
          // borderRadius: "12px",
          // padding: '8px 16px',
          // boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        },
      },
    },
  },
  // Add any other customizations here
  // For example, you can customize the default styles for other components
  // like Typography, Button, Card, etc.
  // You can also add custom breakpoints, spacing, etc.
  // Refer to the MUI documentation for more details on theming:
  // https://mui.com/customization/theming/
  // https://mui.com/customization/breakpoints/
  // https://mui.com/customization/spacing/
  // https://mui.com/customization/typography/
});

export default theme;
